import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { ClientResourceWalletService } from './api/clientResourceWallet.service';
import { ClientWalletTransactionService } from './api/clientWalletTransaction.service';
import { MerchantResourceWalletService } from './api/merchantResourceWallet.service';
import { MerchantWalletService } from './api/merchantWallet.service';
import { MerchantWalletTransactionService } from './api/merchantWalletTransaction.service';
import { SettlementService } from './api/settlement.service';
import { WalletService } from './api/wallet.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    ClientResourceWalletService,
    ClientWalletTransactionService,
    MerchantResourceWalletService,
    MerchantWalletService,
    MerchantWalletTransactionService,
    SettlementService,
    WalletService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
